import AxiosService from "./axiosServices";
const BASE_VIZ_URL = process.env.REACT_APP_R_APIBASE;

// const axiosService = new AxiosService();

const DashboardService = {
  fetchProductAndSites: () => {
    return AxiosService.Post(`${BASE_VIZ_URL}product_site_listing`);
  },

  fetchData: (requestData) => {
    return AxiosService.Post(`${BASE_VIZ_URL}product_site_listing`, {
      params: {
        product: requestData?.product,
        site: requestData?.site,
      },
    });
  },

  genearateKpiTable: (requestData) => {
    return AxiosService.Post(`${BASE_VIZ_URL}generate_kpi_table`, requestData);
  },

  genearateKpiGrpah: (requestData) => {
    return AxiosService.Post(`${BASE_VIZ_URL}generate_kpi_graph`, requestData);
  },

  fetchDashboardFilteredBatchList: (payload) => {
    return AxiosService.Post(`${BASE_VIZ_URL}kpi_batch_preview`, payload).then(
      (res) => res.data,
    );
  },

  fetchTablePlot: (payload) => {
    return AxiosService.Post(`${BASE_VIZ_URL}generate_kpi_graph`, payload).then(
      (res) => res.data,
    );
  },
};

export default DashboardService;
